export class Colors {
  public static readonly PRIMARY_BLUE: string = "#598BFF";
  public static readonly HALO_BLUE: string = "#009DFF";
  public static readonly HALO_GREEN: string = "#80FF4D";
  public static readonly HALO_ORANGE: string = "#FFB600";
  public static readonly HALO_SILVER: string = "#AECAD9";

  public static readonly ALICE_BLUE: string = "#F0F8FF";
  public static readonly ANTIQUE_WHITE: string = "#FAEBD7";
  public static readonly AQUA: string = "#00FFFF";
  public static readonly AQUAMARINE: string = "#7FFFD4";
  public static readonly AZURE: string = "#F0FFFF";
  public static readonly BEIGE: string = "#F5F5DC";
  public static readonly BISQUE: string = "#FFE4C4";
  public static readonly BLACK: string = "#000000";
  public static readonly BLANCHED_ALMOND: string = "#FFEBCD";
  public static readonly BLUE: string = "#0000FF";
  public static readonly BLUE_VIOLET: string = "#8A2BE2";
  public static readonly BROWN: string = "#A52A2A";
  public static readonly BURLY_WOOD: string = "#DEB887";
  public static readonly CADET_BLUE: string = "#5F9EA0";
  public static readonly CHARTREUSE: string = "#7FFF00";
  public static readonly CHOCOLATE: string = "#D2691E";
  public static readonly CORAL: string = "#FF7F50";
  public static readonly CORNFLOWER_BLUE: string = "#6495ED";
  public static readonly CORNSILK: string = "#FFF8DC";
  public static readonly CRIMSON: string = "#DC143C";
  public static readonly CYAN: string = "#00FFFF";
  public static readonly DARK_BLUE: string = "#00008B";
  public static readonly DARK_CYAN: string = "#008B8B";
  public static readonly DARK_GOLDEN_ROD: string = "#B8860B";
  public static readonly DARK_GRAY: string = "#A9A9A9";
  public static readonly DARK_GREEN: string = "#006400";
  public static readonly DARK_KHAKI: string = "#BDB76B";
  public static readonly DARK_MAGENTA: string = "#8B008B";
  public static readonly DARK_OLIVE_GREEN: string = "#556B2F";
  public static readonly DARK_ORANGE: string = "#FF8C00";
  public static readonly DARK_ORCHID: string = "#9932CC";
  public static readonly DARK_RED: string = "#8B0000";
  public static readonly DARK_SALMON: string = "#E9967A";
  public static readonly DARK_SEA_GREEN: string = "#8FBC8F";
  public static readonly DARK_SLATE_BLUE: string = "#483D8B";
  public static readonly DARK_SLATE_GRAY: string = "#2F4F4F";
  public static readonly DARK_TURQUOISE: string = "#00CED1";
  public static readonly DARK_VIOLET: string = "#9400D3";
  public static readonly DEEP_PINK: string = "#FF1493";
  public static readonly DEEP_SKY_BLUE: string = "#00BFFF";
  public static readonly DIM_GRAY: string = "#696969";
  public static readonly DODGER_BLUE: string = "#1E90FF";
  public static readonly FIRE_BRICK: string = "#B22222";
  public static readonly FLORAL_WHITE: string = "#FFFAF0";
  public static readonly FOREST_GREEN: string = "#228B22";
  public static readonly FUCHSIA: string = "#FF00FF";
  public static readonly GAINSBORO: string = "#DCDCDC";
  public static readonly GHOST_WHITE: string = "#F8F8FF";
  public static readonly GOLD: string = "#FFD700";
  public static readonly GOLDEN_ROD: string = "#DAA520";
  public static readonly GRAY: string = "#808080";
  public static readonly GREEN: string = "#008000";
  public static readonly GREEN_YELLOW: string = "#ADFF2F";
  public static readonly HONEY_DEW: string = "#F0FFF0";
  public static readonly HOT_PINK: string = "#FF69B4";
  public static readonly INDIAN_RED: string = "#CD5C5C";
  public static readonly INDIGO: string = "#4B0082";
  public static readonly IVORY: string = "#FFFFF0";
  public static readonly KHAKI: string = "#F0E68C";
  public static readonly LAVENDER: string = "#E6E6FA";
  public static readonly LAVENDER_BLUSH: string = "#FFF0F5";
  public static readonly LAWN_GREEN: string = "#7CFC00";
  public static readonly LEMON_CHIFFON: string = "#FFFACD";
  public static readonly LIGHT_BLUE: string = "#ADD8E6";
  public static readonly LIGHT_CORAL: string = "#F08080";
  public static readonly LIGHT_CYAN: string = "#E0FFFF";
  public static readonly LIGHT_GOLDEN_ROD_YELLOW: string = "#FAFAD2";
  public static readonly LIGHT_GRAY: string = "#D3D3D3";
  public static readonly LIGHT_GREEN: string = "#90EE90";
  public static readonly LIGHT_PINK: string = "#FFB6C1";
  public static readonly LIGHT_SALMON: string = "#FFA07A";
  public static readonly LIGHT_SEA_GREEN: string = "#20B2AA";
  public static readonly LIGHT_SKY_BLUE: string = "#87CEFA";
  public static readonly LIGHT_SLATE_GRAY: string = "#778899";
  public static readonly LIGHT_STEEL_BLUE: string = "#B0C4DE";
  public static readonly LIGHT_YELLOW: string = "#FFFFE0";
  public static readonly LIME: string = "#00FF00";
  public static readonly LIME_GREEN: string = "#32CD32";
  public static readonly LINEN: string = "#FAF0E6";
  public static readonly MAGENTA: string = "#FF00FF";
  public static readonly MAROON: string = "#800000";
  public static readonly MEDIUM_AQUA_MARINE: string = "#66CDAA";
  public static readonly MEDIUM_BLUE: string = "#0000CD";
  public static readonly MEDIUM_ORCHID: string = "#BA55D3";
  public static readonly MEDIUM_PURPLE: string = "#9370DB";
  public static readonly MEDIUM_SEA_GREEN: string = "#3CB371";
  public static readonly MEDIUM_SLATE_BLUE: string = "#7B68EE";
  public static readonly MEDIUM_SPRING_GREEN: string = "#00FA9A";
  public static readonly MEDIUM_TURQUOISE: string = "#48D1CC";
  public static readonly MEDIUM_VIOLET_RED: string = "#C71585";
  public static readonly MIDNIGHT_BLUE: string = "#191970";
  public static readonly MINT_CREAM: string = "#F5FFFA";
  public static readonly MISTY_ROSE: string = "#FFE4E1";
  public static readonly MOCCASIN: string = "#FFE4B5";
  public static readonly NAVAJO_WHITE: string = "#FFDEAD";
  public static readonly NAVY: string = "#000080";
  public static readonly OLD_LACE: string = "#FDF5E6";
  public static readonly OLIVE: string = "#808000";
  public static readonly OLIVE_DRAB: string = "#6B8E23";
  public static readonly ORANGE: string = "#FFA500";
  public static readonly ORANGE_RED: string = "#FF4500";
  public static readonly ORCHID: string = "#DA70D6";
  public static readonly PALE_GOLDEN_ROD: string = "#EEE8AA";
  public static readonly PALE_GREEN: string = "#98FB98";
  public static readonly PALE_TURQUOISE: string = "#AFEEEE";
  public static readonly PALE_VIOLET_RED: string = "#DB7093";
  public static readonly PAPAYA_WHIP: string = "#FFEFD5";
  public static readonly PEACH_PUFF: string = "#FFDAB9";
  public static readonly PERU: string = "#CD853F";
  public static readonly PINK: string = "#FFC0CB";
  public static readonly PLUM: string = "#DDA0DD";
  public static readonly POWDER_BLUE: string = "#B0E0E6";
  public static readonly PURPLE: string = "#800080";
  public static readonly RED: string = "#FF0000";
  public static readonly ROSY_BROWN: string = "#BC8F8F";
  public static readonly ROYAL_BLUE: string = "#4169E1";
  public static readonly SADDLE_BROWN: string = "#8B4513";
  public static readonly SALMON: string = "#FA8072";
  public static readonly SANDY_BROWN: string = "#F4A460";
  public static readonly SEA_GREEN: string = "#2E8B57";
  public static readonly SEA_SHELL: string = "#FFF5EE";
  public static readonly SIENNA: string = "#A0522D";
  public static readonly SILVER: string = "#C0C0C0";
  public static readonly SKY_BLUE: string = "#87CEEB";
  public static readonly SLATE_BLUE: string = "#6A5ACD";
  public static readonly SLATE_GRAY: string = "#708090";
  public static readonly SNOW: string = "#FFFAFA";
  public static readonly SPRING_GREEN: string = "#00FF7F";
  public static readonly STEEL_BLUE: string = "#4682B4";
  public static readonly TAN: string = "#D2B48C";
  public static readonly TEAL: string = "#008080";
  public static readonly THISTLE: string = "#D8BFD8";
  public static readonly TOMATO: string = "#FF6347";
  public static readonly TURQUOISE: string = "#40E0D0";
  public static readonly VIOLET: string = "#EE82EE";
  public static readonly WHEAT: string = "#F5DEB3";
  public static readonly WHITE: string = "#FFFFFF";
  public static readonly WHITE_SMOKE: string = "#F5F5F5";
  public static readonly YELLOW: string = "#FFFF00";
  public static readonly YELLOW_GREEN: string = "#9ACD32";
}

export const PickColors = [
  { background: '#83D62A', color: '#3e6a03' },
  { background: '#42BBF7', color: '#0c4677' },
  { background: '#FFAF38', color: '#7a4307' },
  { background: '#FF342D', color: '#7a0b2b' },
  { background: '#DFFAAA', color: '#3e6a03' },
  { background: '#B3F3FE', color: '#0c4677' },
  { background: '#FFE8AF', color: '#7a4307' },
  { background: '#FFC3AB', color: '#7a0b2b' },
  { background: '#66B81E', color: '#f5fdce' },
  { background: '#3093D4', color: '#d9fef8' },
  { background: '#DB8C28', color: '#fff6d3' },
  { background: '#DB202A', color: '#ffe7d8' },
  { background: '#C5F27D', color: '#3e6a03' },
  { background: '#8DE6FC', color: '#0c4677' },
  { background: '#FFD887', color: '#7a4307' },
  { background: '#FF9A81', color: '#7a0b2b' },
  { background: '#4D9A15', color: '#f5fdce' },
  { background: '#216FB1', color: '#d9fef8' },
  { background: '#B76C1C', color: '#fff6d3' },
  { background: '#B7162C', color: '#ffe7d8' },
  { background: '#AAE65B', color: '#3e6a03' },
  { background: '#70D5FA', color: '#0c4677' },
  { background: '#FFC969', color: '#7a4307' },
  { background: '#FF7461', color: '#7a0b2b' },
  { background: '#367C0D', color: '#f5fdce' },
  { background: '#154F8F', color: '#d9fef8' },
  { background: '#934F11', color: '#fff6d3' },
  { background: '#930E2B', color: '#ffe7d8' },
  { background: '#F1FCD4', color: '#3e6a03' },
  { background: '#D9FBFE', color: '#0c4677' },
  { background: '#FFF5D7', color: '#7a4307' },
  { background: '#FFE4D5', color: '#7a0b2b' },
  { background: '#266608', color: '#f5fdce' },
  { background: '#0C3876', color: '#d9fef8' },
  { background: '#7A3B0A', color: '#fff6d3' },
  { background: '#7A082B', color: '#ffe7d8' }
];
